<template>
    <img
        class="company-image"
        :style="{
            width,
            height,
            maxHeight,
            maxWidth
        }"
        :src="url"
    >
</template>
<script setup>

    import { computed, inject } from 'vue';
    import { CompanyImageType, CompanyImageTypeFallback } from '../enums/company-image-type';

    const store = inject('store');
    const props = defineProps({
        type: {
            type: String,
            required: true,
        },

        fallbackType: {
            type: String,
            default: null,
        },

        height: {
            type: String,
            default: null,
        },

        width: {
            type: String,
            default: null,
        },

        maxHeight: {
            type: String,
            default: null,
        },

        maxWidth: {
            type: String,
            default: null,
        },
    });

    const url = computed(() => {
        switch (props.type) {
            case CompanyImageType.Logo:
                return store.state.companySettings?.logo || getFallbackUrl(props.fallbackType || CompanyImageTypeFallback.FullLogo);
            case CompanyImageType.Mail:
                return store.state.companySettings?.mail_logo || getFallbackUrl(props.fallbackType || CompanyImageTypeFallback.MailLogo);
            case CompanyImageType.Favicon:
                return store.state.companySettings?.favicon || getFallbackUrl(props.fallbackType || CompanyImageTypeFallback.Favicon);
        }

        throw new Error('Type not implemented');
    });

    function getFallbackUrl(type) {
        switch (type) {
            case CompanyImageTypeFallback.FullLogo:
                return require('../assets/lite/Logo-Text-Below.svg');
            case CompanyImageTypeFallback.LogoWithoutText:
                return require('../assets/lite/Logo.svg');
            case CompanyImageTypeFallback.MailLogo:
                return require('../assets/lite/Logo-Text-Below-Mail.png');
            case CompanyImageTypeFallback.Favicon:
                return require('../assets/lite/favicon.ico');
        }

        throw new Error('Fallback type not implemented');
    }
</script>
